import { FEATURES } from "./Data";
import '../App.css'


export default function Features() {
  return (
    <section className="section" id="features">
      <div className="section-inner">

        <div className="tag">Why SwimWay</div>

        <h2 className="sec-title">
          Everything you need <br /> under one roof
        </h2>

        <div className="feat-grid">
          {FEATURES.map((f) => (
            <div className="feat-card" key={f.title}>
              <div className="feat-icon" style={{ background: f.bg }}>
                {f.icon}
              </div>

              <div className="feat-title">{f.title}</div>

              <div className="feat-desc">{f.desc}</div>
            </div>
          ))}
        </div>

      </div>
    </section>
  )
}